import { Stack, TextField } from "@mui/material";

export default function TarifForm({index, tarif, setTarifs}) {
    return (
        <Stack direction='column' spacing={1}>
            <Stack direction="row" gap={1} alignItems="center">
                <TextField select fullWidth label='Type' value={tarif.type} size="small"
                slotProps={{inputLabel:{shrink: true}, select:{native: true}}}
                onChange={(e)=>setTarifs(prev=>{prev[index].type = e.target.value; return [...prev]})} required sx={{minWidth:'200px'}}>
                    <option value="" disabled>Sélectionner un type</option>
                    <option value="normal">Normal</option>
                    <option value="early">Pré-vente</option>
                    <option value="vip">VIP</option>
                </TextField>
                <TextField type='number' size='small' label='Limite' value={tarif.limite} required={tarif.type !== 'normal'} sx={{minWidth:'100px'}}
                onFocus={e => {if(tarif.limite === 0) setTarifs(prev => {prev[index].limite = ''; return [...prev]})}}
                onChange={(e)=>setTarifs(prev=>{prev[index].limite = e.target.value; return [...prev]})} />
            </Stack>
            <Stack direction="row" gap={1} alignItems="center">
                <TextField fullWidth size='small' label='Nom' value={tarif.nom} onChange={(e)=>setTarifs(prev=>{prev[index].nom = e.target.value; return [...prev]})} required sx={{minWidth:'200px'}}/>
                <TextField type='number' size='small' label='Montant' value={tarif.montant} required sx={{minWidth:'100px'}}
                onFocus={e => {if(tarif.montant === 0) setTarifs(prev => {prev[index].montant = ''; return [...prev]})}}
                onChange={(e)=>setTarifs(prev=>{prev[index].montant = e.target.value; return [...prev]})} />
            </Stack>
            <TextField fullWidth size='small' label='Description' value={tarif.description} onChange={(e)=>setTarifs(prev=>{prev[index].description = e.target.value; return [...prev]})} sx={{minWidth:'200px'}}/>
        </Stack>
    )
}